import { CollapsibleTableHeadCell } from '../components/tables/BakeasyCollapsibleTable';
import { HeadCell } from '../components/tables/BakeasyTable';

export const productTableHeaders: HeadCell[] = [
  { id: 'productName', label: 'PRODUCT_NAME', sort: true, width: '200px' },
  { id: 'userProductId', label: 'PRODUCT_ID' },
  { id: 'storeCost', label: 'STORE_COST', align: 'right' },
  { id: 'categoryName', label: 'CATEGORY', sort: true },
  { id: 'subCategoryName', label: 'SUB_CATEGORY', sort: true },
  { id: 'description', label: 'DESCRIPTION' },
  { id: 'status', label: 'STATUS', align: 'center' }
];

export const ingredientTableHeadersForView: HeadCell[] = [
  { id: 'ingredientName', label: 'INGREDIENT_NAME' },
  { id: 'measureType', label: 'MEASURE_TYPE' },
  { id: 'units', label: 'QUANTITY_PER_UNIT' },
  { id: 'price', label: 'PRICE' }
];

export const createOrderProductTableHeaders: HeadCell[] = [
  { id: 'productName', label: 'PRODUCT_NAME', width: '200px' },
  { id: 'userProductId', label: 'PRODUCT_ID', width: '160px' },
  { id: 'quantity', label: 'QUANTITY', width: '100px', disabled: false },
  { id: 'unitPrice', label: 'UNIT_PRICE', width: '100px', numeric: true },
  { id: 'totalprice', label: 'TOTAL_PRICE', width: '100px', numeric: true },
  { id: 'actions', label: 'ACTIONS', align: 'center', width: '100px' }
];

export const orderTableHeaders: HeadCell[] = [
  { id: 'productChecked', label: 'CHECK' },
  { id: 'productName', label: 'PRODUCT_NAME', sort: true, width: '200px' },
  { id: 'userProductId', label: 'PRODUCT_ID' },
  { id: 'price', label: 'STORE_COST', sort: false, align: 'right' },
  { id: 'quantity', label: 'QUANTITY', sort: false, width: '120px' },
  { id: 'categoryName', label: 'CATEGORY', sort: true },
  { id: 'subCategoryName', label: 'SUB_CATEGORY', sort: true },
  { id: 'description', label: 'DESCRIPTION', sort: false }
];

export const orderHistorytableHeaders: HeadCell[] = [
  { id: 'orderId', label: 'ORDER_ID', sort: true },
  { id: 'ponumber', label: 'PO_NUMBER' },
  { id: 'orderDate', label: 'ORDERED_DATE', sort: true },
  { id: 'expecteddate', label: 'EXPECTED_DATE' },
  { id: 'invoiceddate', label: 'INVOICED_DATE' },
  { id: 'ordervalue', label: 'ORDER_VALUE', align: 'right' },
  { id: 'status', label: 'STATUS', align: 'center', sort: true },
  { id: 'duplicate', label: 'DUPLICATE', align: 'center' }
];

export const reportTableHeaders: CollapsibleTableHeadCell[] = [
  { id: 'icon', label: '', width: '30px' },
  { id: 'invoiceId', label: 'INVOICE_ID' },
  { id: 'orderId', label: 'ORDER_ID', width: '200px' },
  { id: 'name', label: 'STORE_NAME', width: '200px' },
  { id: 'storepo', label: 'STORE_PO' },
  { id: 'status', label: 'STATUS' },
  { id: 'orderDate', label: 'ORDER_DATE', width: '150px' },
  { id: 'shippedDate', label: 'SHIPPED_DATE', width: '150px' },
  { id: 'invoicedDate', label: 'INVOICED_DATE', width: '150px' },
  { id: 'invoicedValue', label: 'INVOICED_VALUE', width: '150px', align: 'right' }
];

export const invoiceTableHeaders: CollapsibleTableHeadCell[] = [
  { id: 'invoiceId', label: 'INVOICE_ID' },
  { id: 'subOrderId', label: 'SUBORDER_ID' },
  { id: 'status', label: 'STATUS' },
  { id: 'orderDate', label: 'ORDER_DATE' },
  { id: 'shipDate', label: 'SHIPPED_DATE', shippingMemo: true },
  { id: 'invoicedDate', label: 'INVOICED_DATE' },
  { id: 'invoicedValue', label: 'INVOICED_VALUE', align: 'right' }
];

export const messageTableHeaders: HeadCell[] = [
  { id: 'messageDateTime', label: 'DATE_MM_DD_YYYY', width: '120px' },
  { id: 'from', label: 'FROM' },
  { id: 'to', label: 'TO', width: '180px' },
  { id: 'priority', label: 'PRIORITY' },
  { id: 'subject', label: 'SUBJECT', width: '200px' },
  { id: 'recsent', label: 'STATUS' },
  { id: 'content', label: 'CONTENT', width: '200px' },
  { id: 'actions', label: 'ACTIONS' }
];

export const shippingTableHeaders: HeadCell[] = [
  { id: 'shippingId', label: 'SHIPPING_ID', sort: true },
  { id: 'order_Id', label: 'ORDER_ID' },
  { id: 'storeName', label: 'STORE_NAME', sort: true },
  { id: 'storePo', label: 'STORE_PO' },
  { id: 'dueDate', label: 'DATE_TO_BE_DELIVERED', sort: true },
  { id: 'shippedDate', label: 'SHIPPED_DATE' },
  { id: 'totalPrice', label: 'TOTAL_PRICE', align: 'right' },
  { id: 'status', label: 'STATUS', align: 'center' }
];
